import request from "@/utils/request";

/**
 * 待审核列表
 * @param params
 * @returns {AxiosPromise}
 */
export function auditPage(params){
    return request({
        url: '/system/order-flow/audit',
        method: 'get',
        params
    })
}

/**
 * 领取待审核任务
 * @param params
 * @returns {*}
 */
export function getTask(params) {
    return request({
        url: '/system/order-flow/get-task',
        method: 'post',
        params
    })
}
/**
 * 领取待审核任务
 * @param params
 * @returns {*}
 */
export function backTask(params) {
    return request({
        url: '/system/order-flow/get-task/back',
        method: 'post',
        params
    })
}
/**
 * 已领取的任务
 * @param params
 * @returns {*}
 */
export function gainPage(params) {
    return request({
        url: '/system/order-flow/gain',
        method: 'get',
        params
    })
}

/**
 * 审批
 * @returns {*}
 * @param data
 */
export function auditTask(data) {
    return request({
        url: '/system/order-flow/audit',
        method: 'post',
        data
    })
}
/**
 * 审批记录
 * @returns {*}
 * @param orderNo
 */
export function auditRecord(orderNo) {
    return request({
        url: `/system/order-flow-record/list/${orderNo}`,
        method: 'get'
    })
}

/**
 * 审批订单数据
 * @returns {AxiosPromise}
 * @param orderNo
 */
export function getAuditData(orderNo){
    return request({
        url: `/system/order-flow/audit/${orderNo}`,
        method: 'get'
    })
}
